import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../store";
import { useForm } from "react-hook-form";
import provisional from "../../Assets/images/provisional_landing_image.png";
import divider from "../../Assets/images/lpDividerLine.png";
import { useTranslation } from "react-i18next";
import * as httpClient from "../../../util/httpClient";
import PSSBannerMessage from "../PSSBannerMessage/PSSBannerMessage";

const CommereceBank = (props: any) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const partnerLanguageOptions = useSelector(
        (state: ApplicationState) => state.configurationState && state.configurationState.partnerLanguageOptions && state.configurationState.partnerLanguageOptions
    );
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const partnerID: number = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId
            : 0
    );

    useEffect(() => {
        setTimeout(() => {
            let language =
                !!partnerLanguageOptions && partnerLanguageOptions.length > 1
                    ? document.cookie.split(";").filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language").length > 0
                        ? !!document.cookie
                              .split(";")
                              .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                              .split("=")[1]
                            ? document.cookie
                                  .split(";")
                                  .filter((cookieElement: string) => cookieElement.split("=")[0].trim() == "user_prefered_language")[0]
                                  .split("=")[1]
                            : "en"
                        : "en"
                    : "en";
            i18nLang.changeLanguage(language);
        });
    }, []);
    const { register, errors, handleSubmit, reset, trigger, setValue } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
        defaultValues: {
            firstName: "",
            lastName: "",
            zip: "",
            customerSecret: "",
        },
    });
    const [showAccessCodeField, setShowAccessCodeField] = useState(false);
    const [showErrorValdation, setshowErrorValdation] = useState(false);
    const [state, setState] = useState({
        firstName: "",
        lastName: "",
        zip: "",
        customerSecret: "",
        showErrorMessage: false,
        errorMsg: "AccessCode is Required",
        isLoading: false,
    });
    const handleInputChange = (event: any) => {
        const target = event.target;
        const value = target.value === "checkbox" ? target.checked : target.value;
        const name = target.name;
        if (name === "") {
            setState({
                ...state,
                [name]: value,
                showErrorMessage: false,
            });
        } else {
            setState({
                ...state,
                [name]: value,
            });
        }
    };

    const onSubmit = (data: any) => {
        setShowAccessCodeField(false);
        if (data.firstName == "" || data.lastName == "" || data.zip == "" || data.customerSecret == "" ) { setshowErrorValdation(true); }
        setState({ ...state, isLoading: true, showErrorMessage: true });
        const requestBody = {
            customerSecret: data.customerSecret,
            firstName: data.firstName,
            lastName: data.lastName,
            zip: data.zip,
            partnerID: partnerID,
        };
        httpClient
            .sendRequest("POST", "api/PssLandingPage/GetPssLandingPage2?enrollFileRequired=true", requestBody)
            .then((data) => {
                if (data.provisionalResponseLanding.length === 0) {
                    setShowAccessCodeField(true);
                    setshowErrorValdation(false);
                } else if (data.provisionalResponseLanding.length != 0) {
                    props.history.push({
                        pathname:
                            "/Register?Type=" +
                            data.provisionalResponseLanding[0].contractStatus +
                            "&VALUE=" +
                            data.provisionalResponseLanding[0].provisionalID +
                            "&GNDNRLL=PSS",
                    });
                    window.location.reload();
                }
            })
            .catch(function (error) {
                reset();
                trigger();
                setState({ ...state, showErrorMessage: true, errorMsg: "Something went wrong. Please try again.", isLoading: false });
            });
    };
    const handleAccessCode = () => {
        props.history.push({
            pathname: "ProvisionalResponseLandingPage1",
        });
    };
    return (
        <React.Fragment>
            {showAccessCodeField == true ? (
                <PSSBannerMessage layout={"psscommercebank"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
            ) : showErrorValdation == true ? (
                    <PSSBannerMessage layout={"psslandingerrormessage"} showAccessCodeField={showAccessCodeField} setShowAccessCodeField={setShowAccessCodeField} />
            ) : (
                <div className="retailer_text"></div>
            )}
            <main is="x3d" id="l-page-content main-content" aria-labelledby="title-page">
                <div className="row l-page-container">
                    <div
                        style={{
                            backgroundImage: `url(${provisional})`,
                        }}
                        id="main-left-bg"
                    ></div>
                    <div className="pss-right-content">
                        <h2>Your Identity Protection Begins Today!</h2>
                        <div className="receipt-code-copy pss2-receipt-code-copy">For verification purposes, please provide the information requested below.</div>
                        <form id="form-member-login" onSubmit={handleSubmit(onSubmit)}>
                            <div className="input-content pss2-input-content">
                                <div className="form-row pss-forms">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="firstName">
                                            First Name
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            className="access-code-input-pin"
                                            type="text"
                                            id="firstName"
                                            name="firstName"
                                            onChange={handleInputChange}
                                            ref={register({
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.firstName && errors.firstName.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">First Name is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                <div className="form-row pss-forms">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="lastName">
                                            Last Name
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            className="access-code-input-pin"
                                            type="text"
                                            id="lastName"
                                            name="lastName"
                                            onChange={handleInputChange}
                                            ref={register({
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.lastName && errors.lastName.type === "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">Last Name is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="form-row pss-forms">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="zip">
                                            ZIP Code
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            className="access-code-input-pin"
                                            type="text"
                                            id="zip"
                                            name="zip"
                                            onChange={handleInputChange}
                                            ref={register({
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.zip && errors.zip.type === "required" &&(
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">Zip Code is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className="form-row pss-forms">
                                    <div className="form-label">
                                        <label className="access-code-label pss2-access-code-label" htmlFor="customerSecret">
                                            Last 4 digits of SSN
                                        </label>
                                    </div>
                                    <div className="form-input">
                                        <input
                                            className="access-code-input-pin"
                                            type="text"
                                            id="customerSecret"
                                            name="customerSecret"
                                            onChange={handleInputChange}
                                            ref={register({
                                                maxLength: 100,
                                            })}
                                        />
                                    </div>
                                    {errors.customerSecret && errors.customerSecret.type == "required" && (
                                        <div className="form-row">
                                            <div role="alert" className="col-xs-12 col-no-gutter">
                                                <span className="error-msg">Last 4 digits of SSN is required</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="row getstarted-rightcontent">
                                <input type="submit" onClick={() => handleSubmit(onSubmit)} value="Get Started" className="mobile-button" />
                                <div className="pss2-right-content-links">
                                    <a href="javascript:void(0)" onClick={() => handleAccessCode()} className="login-link">
                                        Enter your Access Code
                                    </a>
                                    <a href="/" className="login-link">
                                        Click here to Log In
                                    </a>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="divider-img pss-divider">
                        <img src={divider} alt="" />
                    </div>
                </div>
            </main>
        </React.Fragment>
    );
};
export default CommereceBank;
